import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c833612"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "new-customer-page main-content-wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "main-content-page-title w-full" }, "顧客新規作成", -1))

import CustomerNew from "./components/New/index.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'new',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_Toast = _resolveComponent("Toast")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(CustomerNew)
    ]),
    _createVNode(_component_Toast, { position: "top-center" })
  ], 64))
}
}

})